module.exports = __webpack_public_path__ + "static/img/logo-white.5f90c82a.png";